import logo from '../resources/logo.png'
import {Link} from 'react-router-dom'

const ResultsPageFooter = () => {
    return ( 
        <div className="resultspage-footer">
       		<div className="resultspage-footer-wrapper">
       			<div className="resultspage-footer-subcont">
       			<a href="/" className="resultspage-footer-a">
	            	<img className="resultspage-footer-logo" src={logo} alt="logo"/>
	            	<span className="resultspage-footer-logo-text">Trivtionary</span>
	            </a>
	            <div>
		            <Link to="/privacy" className="footer-a">Privacy</Link>
		            <Link to="/about" className="footer-a">About</Link>
		            <a href="http://joepetryan.rf.gd" className="footer-a">JRQ</a>
	            </div>
       			</div>
       		</div>
	    </div>
    )
}

export default ResultsPageFooter